var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionFacebook } from "./actionFacebookConnect";
var initial = {
    fbConnected: false,
    serverConnectedPlayer: {},
};
export var reducerFacebook = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionFacebook.DifferentAccountConnected:
            return __assign({}, state, { serverConnectedPlayer: action.serverConnectedPlayer });
        case TypeActionFacebook.Connected:
            return __assign({}, initial, { fbConnected: true });
        case TypeActionFacebook.Disconnected:
            return __assign({}, state, { fbConnected: false });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/reducerFacbookConnect.ts
// module id = 2528
// module chunks = 3